import { render, staticRenderFns } from "./warehouseData.vue?vue&type=template&id=b4ab9d52&scoped=true&"
import script from "./warehouseData.vue?vue&type=script&lang=js&"
export * from "./warehouseData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ab9d52",
  null
  
)

export default component.exports